module.exports = __webpack_public_path__ + "static/media/active-swap.c1804c06.svg";